export { PLACEHOLDER_IMAGE_IMAGE } from './lib/di';
export { ProgressiveImageComponent } from './lib/components/progressive-image/progressive-image.component';
export { ImageComponent } from './lib/components/image/image.component';
export { ProgressiveImageFallbackDirective } from './lib/directives/progressive-image-fallback.directive';
export { ProgressiveImagePlaceholderDirective } from './lib/directives/progressive-image-placeholder.directive';
export { ProgressiveImageDirective } from './lib/directives/progressive-image.directive';
export { IconErrorDirective } from './lib/directives/icon-error.directive';
